import * as React from 'react';
import { RouteComponentProps, withRouter, Link, NavLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import "./WhoAmI.less";
import { PageProps } from "src/models/common/ComponentProps";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import { Row, Col, Select, Icon, Radio } from "antd";
import UserAction from "src/redux/UserActions";
import CheckpointAction from "src/redux/CheckpointActions";
import UserMeInfo from "src/models/account/UserMeInfo";
import { UserState } from "src/redux/UserReducer";
import { MissionState } from "src/redux/CheckpointReducer";
import { Grades } from "src/constants/Grades";
import { Planets } from "src/constants/Planets";
import { Checkpoints } from "src/constants/Checkpoints";
import { Roles } from "src/constants/Roles";
import DebugUtil from "src/utils/DebugUtil";
import { RadioChangeEvent } from "antd/lib/radio";
import FullCheckpointStatusDTO from "src/models/frontend/redux/FullCheckpointStatusDTO";

interface WhoAmILocationProps {
    gradeId: number;
    planetId: number;
    checkpointId: number;
}

interface WhoAmIState {
    isLoading: boolean;
}

interface WhoAmIProps extends PageProps<{}> {
    // From Redux
    Mission: MissionState;
    User: UserState;
    setLogin: (request: UserMeInfo) => void;
    setCheckpoint: (request: FullCheckpointStatusDTO) => void;
    doAThing: () => void;
}

class WhoAmI extends React.Component<WhoAmIProps, WhoAmIState> {
    constructor(props: WhoAmIProps) {
        super(props);
        bindAllOfThis(this, WhoAmI.prototype);

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        let locationState = (this.props.location.state as WhoAmILocationProps);
        if (locationState != null) {
            this.props.setLogin({
                ...this.props.User,
                gradeId: locationState.gradeId
            });
            this.props.setCheckpoint({
                ...this.props.Mission,
                current: {
                    ...this.props.Mission.current,
                    planetId: locationState.planetId,
                    checkpointId: locationState.checkpointId,
                },
                currentDirection: "forwards",
            });
        } else {
            this.persistChanges();
        }
        this.setState({
            isLoading: false
        });
    }

    handleGradeChange(value: RadioChangeEvent) {
        this.props.setLogin({
            ...this.props.User as UserMeInfo,
            gradeId: value.target.value
        });
        this.persistChanges();
    }

    handlePlanetChange(value: RadioChangeEvent) {
        this.props.setCheckpoint({
            ...this.props.Mission,
            current: {
                ...this.props.Mission.current,
                planetId: value.target.value,
            },
            currentDirection: "forwards",
        });
        this.persistChanges();
    }

    handleCheckpointChange(value: RadioChangeEvent) {
        this.props.setCheckpoint({
            ...this.props.Mission,
            current: {
                ...this.props.Mission.current,
                checkpointId: value.target.value
            },
            currentDirection: "forwards",
        });
        this.persistChanges();
    }

    persistChanges() {
        setTimeout(() => {
            this.props.history.push({
                pathname: Routes.WHO_AM_I,
                state: {
                    gradeId: this.props.User.gradeId,
                    planetId: this.props.Mission.current.planetId,
                    checkpointId: this.props.Mission.current.checkpointId
                } as WhoAmILocationProps
            });
        }, 100);
    }

    hardRefresh() {
        this.props.history.replace({
            pathname: Routes.WHO_AM_I,
            state: {}
        });
        window.location.reload();
    }

    renderGrades() {
        return <Radio.Group value={Grades.FindById(this.props.User.gradeId).id} onChange={this.handleGradeChange} buttonStyle="solid">
            {Grades.All.map(grade => <Radio.Button value={grade.id} key={grade.id}>{grade.name}</Radio.Button>)}
        </Radio.Group>;
    }

    renderPlanet() {
        return <Radio.Group value={Planets.FindById(this.props.Mission.current.planetId).id} onChange={this.handlePlanetChange} buttonStyle="solid">
            {Planets.All.map(planet => <Radio.Button value={planet.id} key={planet.id}  >{planet.name}</Radio.Button>)}
        </Radio.Group>;
    }

    renderCheckpoint() {
        return <Radio.Group value={Checkpoints.FindById(this.props.Mission.current.checkpointId).id} onChange={this.handleCheckpointChange} buttonStyle="solid">
            {Checkpoints.All.map(checkpoint => <Radio.Button value={checkpoint.id} key={checkpoint.id}>{checkpoint.name}</Radio.Button>)}
        </Radio.Group>;
    }

    renderGrid() {
        let items: { name: string, value: any }[] = [
            { name: "Name", value: `${this.props.User.lastName}, ${this.props.User.firstName}` },
            { name: "Email", value: this.props.User.email },
            { name: "Role", value: Roles.FindById(this.props.User.roleID).name },
            { name: "Grade", value: this.renderGrades() },
            { name: "Planet", value: this.renderPlanet() },
            { name: "Checkpoint", value: this.renderCheckpoint() },
        ];
        return items.map(item => {
            return <div className="gridlines" key={item.name}>
                <Col span={6}>{item.name}</Col>
                <Col span={18}>
                    {item.value}
                </Col>
            </div>;
        });
    }

    render() {
        if (!DebugUtil.isDebugEnabled()) {
            return <Redirect to={Routes.PAGE_NOT_FOUND} />;
        }
        if (this.state.isLoading) {
            return null;
        }
        return <div className="whoami">
            <h2>Welcome to the Who Am I? Page!</h2>
            <p>This page will allow you to temporarily change your user information. These are not persisted, so experiment away!</p>
            <p>Note: Changing checkpoints/planets will not immediately update. However, browsing the student pages will cause the changes to persist</p>
            <br />
            <p><b>Page will now hold onto the selected items below, if you refresh from this page</b></p>

            <Row>
                <Col span={18}>{this.renderGrid()}</Col>
                <Col span={4}>
                    <Row>
                        <NavLink to={Routes.WHO_AM_I} onClick={this.hardRefresh}>
                            <Icon type="profile" theme="twoTone" /> Hard Refresh
                        </NavLink>
                    </Row>
                    <Row>
                        <NavLink to={Routes.ADMIN_CLIENTS}>
                            <Icon type="profile" /> Admin Home
                        </NavLink>
                    </Row>
                    <Row>
                        <NavLink to={Routes.STUDENT_HOME}>
                            <Icon type="profile" /> Student Home
                        </NavLink>
                    </Row>
                </Col>
            </Row>
        </div>;
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        setLogin: (request: UserMeInfo) => UserAction.SetLogin(dispatch, request),
        setCheckpoint: (request: FullCheckpointStatusDTO) => CheckpointAction.Debug_SetCheckpoint(dispatch, request),
    });
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User,
        Mission: state.Mission,
        Constants: state.Constants
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WhoAmI);



// WEBPACK FOOTER //
// ./src/pages/developer/WhoAmI.tsx